import Component from "../../lib/component";

export const ReplyTogglerConfig = {
    baseHtmlClass: 'review__reply_toggler',
    selector: '.review__reply_toggler',
};

export class ReplyToggler extends Component {

    constructor(id_or_element, review) {
        super({
            element: id_or_element,
            config: ReplyTogglerConfig
        });

        this.review = review;

        this.originalActionText = this.element.textContent;

        this.element.addEventListener('click', this.handleReplyTogglerClick.bind(this));

        this.render();
    }

    handleReplyTogglerClick() {
        if (!this.review) return;
        this.review.handleReplyTogglerClick();
    }

    render() {
        if (this.review) {
            if (this.review.viewingReply) {
                this.element.innerText = 'Hide Reply';
            } else {
                this.element.innerText = this.originalActionText;
            }
        }
    }

}
